import React from 'react';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';

const DirectSignup = () => {
  const { authStore } = useRootStore();
  const redirectAuth = async () => authStore.signup();
  React.useEffect(() => {
    redirectAuth();
  }, []);

  return <Spinner />;
};

export default DirectSignup;
